import * as React from 'react';

type TDialogAttributes = Pick<React.HTMLAttributes<HTMLDivElement>, 'role' | 'aria-modal' | 'aria-labelledby'>;

interface IDialogShellProps {
  children: React.ReactNode;
  rootProps?: TDialogAttributes;
  panelProps?: TDialogAttributes;
  rootTestId?: string;
  panelTestId?: string;
}

const PANEL_STYLE: React.CSSProperties = {
  backgroundColor: 'var(--ex3d-dialog-bg-color, var(--ex3d-dealer-white))',
  color: 'var(--ex3d-dialog-text-color, var(--ex3d-dealer-gray-900))',
  borderRadius: 'var(--ex3d-dialog-border-radius, 0.5rem)',
  fontFamily: 'var(--ex3d-dialog-font-family, inherit)',
};

/** Shared backdrop, viewport frame, and themed panel for modal dialogs. */
export default function DialogShell({ children, rootProps, panelProps, rootTestId, panelTestId }: IDialogShellProps) {
  return (
    <div {...rootProps} data-testid={rootTestId} className="relative z-[101]">
      <div
        part="dialog-backdrop"
        className="fixed inset-0 transition-opacity"
        style={{
          backgroundColor: 'var(--ex3d-dialog-backdrop-color, var(--groupui-vwgroup-ref-color-deep-space-blue-900-80))',
        }}
        aria-hidden="true"
      />
      <div className="fixed inset-0 z-[102] w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div
            {...panelProps}
            data-testid={panelTestId}
            part="dialog"
            className="relative overflow-hidden px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
            style={PANEL_STYLE}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
